export default "__VITE_ASSET__C5HeRa3I__"